import React, { useState, useEffect } from 'react'
import { Input, Table, Button, Modal, message, Spin, Alert } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
const { Search } = Input
import sysApi from '../../../api/sys'

import './index.scss'

const FlowCategory = (props) => {
    const [cateList, setCateList] = useState([])
    const [loading, setLoading] = useState(false)
    const [imgUrl, setImgUrl] = useState()
    const [modalVisible, setModalVisible] = useState(false)
    const [imgLoading, setImgLoading] = useState(false)

    const getList = () => {
        setLoading(true)
        sysApi.getAllProcess().then(res => {
            if (res.status !== '0') return
            setLoading(false)
            setCateList(res.data)
        })
    }

    useState(() => {
        getList()
    }, [])

    const delItem = (item) => {
        const { deploymentId, id } = item
        Modal.confirm({
            title: '删除流程定义',
            icon: <ExclamationCircleOutlined />,
            content: '此操作将永久删除该流程定义, 是否继续?',
            okText: '确认',
            cancelText: '取消',
            onOk: async () => {
                const res = await sysApi.delFlowableById({processDefId: id, deploymentId})
                if ( res.status == '0' ) {
                  message.success('删除成功')
                  getList()
                }
            }
        })
    }

    const viewInfo = (item) => {
      setModalVisible(true)
      setImgLoading(true)
      sysApi.viewProcessImg({id: item.id}).then(res => {
        let binaryData = []
        binaryData.push(res)
        const objectUrl = window.URL.createObjectURL(new Blob(binaryData))
        setImgLoading(false)
        setImgUrl(objectUrl)
      })
    }

    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            align: 'center',
            key: 'id'
        },
        {
            title: '流程名称',
            dataIndex: 'name',
            align: 'center',
            key: 'name',
        },
        {
            title: 'key',
            dataIndex: 'key',
            align: 'center',
            key: 'key'
        },
        {
            title: '描述',
            dataIndex: 'description',
            align: 'center',
            key: 'description',
            render: _t => _t ? _t : '-'
        },
        {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            key: 'action',
            render: (_t, record) => {
                return (
                    <>
                        {/* <Button size='small' type="primary" onClick={ () => viewInfo(record) } style={{marginRight: 10}}>详情</Button> */}
                        <Button className='deleteBtn' onClick={ () => delItem(record) } size='small' type="primary" style={{marginRight: 10}}>删除</Button>
                    </>
                )
            }
        }
    ]

    let str = '${planCost>=100 && planCost<1000}'

    return (
        <div className='flowCategory-container'>
            <p style={{color: 'red', opacity: '.8'}}>
              注：修改外委工单审批流程中的金额档次时，只需要按照示例修改流转条件表达式即可，不要更改变量名（planCost）。示例：100&lt;=计划金额&lt;1000，表达式为：
              {str}
            </p>
            <div className='flowCategory-table'>
                <Table
                    loading={loading}
                    pagination={false}
                    rowKey={record => record.id}
                    columns={columns}
                    dataSource={cateList}
                />
            </div>
            <Modal
                title="详情"
                open={modalVisible}
                onCancel={ () => setModalVisible(false) }
                onOk={ () => setModalVisible(false) }
            >
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  {imgLoading ? <Spin size="middle" /> : <img style={{width: '100%'}} src={imgUrl} />}
              </div>
            </Modal>
        </div>
    )
}

export default FlowCategory